import { combineReducers } from "redux";

import Auth from "./auth/reducer";
import Notification from "./notification/reducer";
import ViewExams from "../pages/viewOrders/reducer";
import DashBoardResult from "../pages/dashBoard/reducer"
import DashBoardMapping from "../pages/dashBoard/reducerMapping"
import ViewCandidates from "../pages/viewCandidates/reducer"
import DashBoardReport from "../pages/dashboardReport/reducer"
import ViewFeedback from "../pages/feedBack/reducer"
import LegacyExam from "../pages/borExams/reducer"
import LegacyCandidates from "../pages/legacyCandidates/reducer"
import SpecialSlots from "../pages/specialSlots/reducer";
import ExamSchedule from "../pages/examSchedule/reducer";
import PaymentVerify from "../pages/paymentVerify/reducer";
import SpecialSlotStudent from "../pages/specialSlotDetail/reducer";
import UsersList from "../pages/viewUsers/reducer";
import Cadre from "../pages/viewCadre/reducer";
import SubjectList from "../pages/subjectDetails/reducer"
// import ViewOrdersDetails from "../pages/viewOrderDetailsPage/reducer";
// import AddQuestions from "../pages/addQuestion/reducer";
// import QuestionPaper from "../pages/viewQuestionPaper/reducer";
// import PublicDataDetails from "./publicData/reducer";
// import ScheduleData from "../pages/viewSchedules/reducer"
// import SyllabusData from "../pages/viewSyllabus/reducer"
// import PlanDetails from "../pages/viewPlans/reducer"
// import FeeData from "../pages/viewFees/reducer"
// import CouponData from "../pages/viewCoupons/reducer"
// import AddCourses from "../pages/configurationsPage/course/reducer";
// import ViewSubject from "../pages/configurationsPage/subject/reducer"
// import ViewSyllabus from "../pages/configurationsPage/syllabus/reducer"
// import ViewChapter from "../pages/configurationsPage/chapter/reducer"
// import ViewPortion from "../pages/configurationsPage/portion/reducer"
// import ViewGroup from "../pages/configurationsPage/group/reducer"
// import ViewSession from "../pages/configurationsPage/session/reducer"
// import ViewGst from "../pages/configurationsPage/gst/reducer"
// import ViewService from "../pages/configurationsPage/sservices/reducer"
// import UserReducer from "../pages/viewUser/reducer"
// import AnswerReducer from "../pages/viewStudents/reducer"
// import CheckerReducer from "../pages/viewCheckers/reducer"
// import CheckerAnswerReducer from "../pages/checkerPage/viewPapers/reducer"
const rootReducer = combineReducers({
  Notification,
  Auth,
  ViewExams,
  DashBoardResult,
  DashBoardMapping,
  ViewCandidates,
  DashBoardReport,
  ViewFeedback,
  LegacyExam,
  LegacyCandidates,
  SpecialSlots,
  ExamSchedule,
  PaymentVerify,
  SpecialSlotStudent,
  UsersList,
  Cadre,
  SubjectList,
  // ViewOrdersDetails,
  // AddQuestions,
  // QuestionPaper,
  // PublicDataDetails,
  // ScheduleData,
  // SyllabusData,
  // PlanDetails,
  // FeeData,
  // CouponData,
  // AddCourses,
  // ViewSubject,
  // ViewSyllabus,
  // ViewChapter,
  // ViewPortion,
  // ViewGroup,
  // ViewSession,
  // ViewGst,
  // ViewService,
  // UserReducer,
  // AnswerReducer,
  // CheckerReducer,
  // CheckerAnswerReducer
});

export default rootReducer;
